import Vue from 'vue'
import Vuex from 'vuex'

import mutations        from './mutations'
import getters          from './getters'
import actions          from './actions'

import intro            from '../data/intro'
import members          from '../data/members'
import moduleCampus     from './module/campus'
import moduleDiscover   from './module/discover'
import moduleRecruit    from './module/recruit'
import moduleBrowser    from './module/browser'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        browser: moduleBrowser,
        discover: moduleDiscover,
        recruit: moduleRecruit,
        campus: moduleCampus,
    },
    state: {
        intro,
        members,
        visible: {
            stories: false,
        },
        menu: {
            items: {},
            opened: false,
            submenu: false,
        },
        user: {
            name: '',
            type: 'student'
        },
    },
    actions,
    getters,
    mutations
})

export default store
